import Text from '@sureapp/wl-toggle-common/dist/components/Text';

import classes from './UmpdModalContent.module.css';

function UmpdModalContent() {
  return (
    <div className={classes.root}>
      <Text variant="body1">
        This can help you cover physical damage to your car if you&apos;re hit
        by a driver who isn&apos;t insured.
      </Text>
      <Text variant="body1">
        If you pick{' '}
        <strong>
          Uninsured Motorist -{' '}
          <span className={classes.highlighted_addOn}>Reduced By</span>
        </strong>
        , we&apos;ll pay you up to the difference between the at-fault
        driver&apos;s Liability coverage and your coverage limit.
      </Text>
      <Text variant="body1">
        If you pick{' '}
        <strong>
          Uninsured Motorist -{' '}
          <span className={classes.highlighted_addOn}>Added On</span>
        </strong>
        , we&apos;ll pay for your damage in addition to the at-fault
        driver&apos;s Liability coverage, up to your coverage limit.
      </Text>
      <Text variant="body1">
        You&apos;ll pick either{' '}
        <strong>
          <span className={classes.highlighted_addOn}>Reduced By</span>
        </strong>{' '}
        or{' '}
        <strong>
          <span className={classes.highlighted_addOn}>Added On</span>
        </strong>{' '}
        with your Uninsured Motorist Bodily Injury (UMBI) coverage limit
        selection.
      </Text>
    </div>
  );
}

export default UmpdModalContent;
